export const translations = {
  en: {
    app_name: "AI Absorption Sandbox",
    app_sub: "Value & Absorption Simulator",
    login: "Sign In",
    logout: "Sign Out",
    email: "Email",
    password: "Password",
    login_title: "Welcome back",
    login_desc: "Sign in to the Enterprise AI Value & Absorption Sandbox",
    invalid_login: "Invalid email or password",
    demo_hint: "Administrator access only. Sign in with your administrator account.",
    unauthorized_title: "Access denied",
    unauthorized_desc: "The Enterprise AI Value & Absorption Sandbox is restricted to administrators. Your account does not have the 'admin' role, so no application screens or data can be displayed.",
    unauthorized_hint: "Contact your administrator to have your role upgraded, then sign in again.",
    nav_dashboard: "Executive Dashboard",
    nav_usecases: "Use Cases",
    nav_absorption: "Absorption Center",
    nav_integrations: "Integrations",
    nav_admin: "Administration",
    nav_audio: "Audio Logs",
    dashboard: "Executive Dashboard",
    portfolio_value: "AI Portfolio Value",
    realised_value: "Realised Value",
    potential_value: "Potential Value",
    annual_value: "Estimated Annual Value",
    active_models: "Total Use Cases",
    high_risk: "High Risk Use Cases",
    roi: "Portfolio ROI",
    avg_adoption: "Avg Adoption",
    hidden_cost: "The Hidden Cost of AI",
    hidden_cost_desc: "Absorption is the largest hidden cost — technology alone does not scale value.",
    layer_readiness: "Five-Layer Readiness",
    top_roi: "Top ROI Use Cases",
    critical_priority: "Critical Risk Priority",
    usecases_by_domain: "Use Cases by Domain",
    use_cases: "Use Cases",
    use_cases_count: "100 Enterprise AI Use Cases",
    search: "Search use cases...",
    all: "All",
    domain: "Domain",
    status: "Status",
    risk: "Risk",
    readiness: "Readiness",
    owner: "Owner",
    value: "Value",
    export: "Export CSV",
    view_details: "View Details",
    model: "Model",
    system: "System",
    operation: "Operation",
    absorption: "Absorption",
    outcome: "Outcome",
    score: "Score",
    gaps: "Identified Gaps",
    actions: "Action Items",
    no_gaps: "No gaps — layer is ready",
    overall_readiness: "Overall Readiness",
    business_owner: "Business Owner",
    ai_owner: "AI Owner",
    implementation_cost: "Implementation Cost",
    operating_cost: "Annual Operating Cost",
    estimated_benefit: "Estimated Benefit",
    adoption_rate: "Adoption Rate",
    not_proven: "Technology works, but organisational value has not yet been proven.",
    absorption_center: "Absorption Center",
    absorption_readiness: "Absorption Readiness",
    absorption_desc: "Production-ready does not mean organisation-ready. Value only scales when behaviour, ownership and workflow change.",
    readiness_dimensions: "Readiness Dimensions",
    at_risk_absorption: "Use Cases At Absorption Risk",
    integrations: "Integrations & Functions",
    integrations_desc: "Extend the sandbox with custom functions and API integrations.",
    add_integration: "Add Integration",
    connected: "Connected",
    not_connected: "Not Connected",
    administration: "Administration",
    users: "Users",
    groups: "Groups",
    content: "Content",
    activity: "Activity Log",
    add_user: "Add User",
    add_group: "Add Group",
    name: "Name",
    role: "Role",
    group: "Group",
    actions_col: "Actions",
    members: "Members",
    upload_content: "Upload Content",
    download: "Download",
    filename: "File Name",
    size: "Size",
    uploaded_by: "Uploaded By",
    admin_only: "Only the default administrator can upload and download content.",
    audio_logs: "Read-Aloud Audio Logs",
    audio_logs_desc: "Every spoken summary is logged with role, screen and duration.",
    screen: "Screen",
    duration: "Duration",
    language: "Language",
    read_aloud: "Read Aloud",
    generating_summary: "Generating summary...",
    play: "Play",
    pause: "Pause",
    stop: "Stop",
    speed: "Speed",
    transcript: "Transcript",
    copy: "Copy",
    voice_summary: "Voice Summary",
    voice_ask: "Ask by voice",
    listening: "Listening...",
    transcribing: "Transcribing...",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    confirm: "Confirm",
    total_use_cases: "Total Use Cases",
    close: "Close",
    principle: "THE DEMO CAN WORK. THE TECHNOLOGY CAN WORK. BUT IF BEHAVIOUR, OWNERSHIP AND WORKFLOW DO NOT CHANGE, VALUE DOES NOT SCALE.",
  },
  ar: {
    app_name: "منصة تبني الذكاء الاصطناعي",
    app_sub: "محاكي القيمة والتبني",
    login: "تسجيل الدخول",
    logout: "تسجيل الخروج",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    login_title: "مرحبًا بعودتك",
    login_desc: "سجّل الدخول إلى منصة قيمة وتبني الذكاء الاصطناعي المؤسسي",
    invalid_login: "بريد إلكتروني أو كلمة مرور غير صحيحة",
    demo_hint: "الوصول مقصور على المسؤولين. سجّل الدخول بحساب المسؤول.",
    unauthorized_title: "تم رفض الوصول",
    unauthorized_desc: "منصة قيمة وتبني الذكاء الاصطناعي المؤسسي مقصورة على المسؤولين. لا يمتلك حسابك دور 'admin'، لذلك لا يمكن عرض أي شاشات أو بيانات.",
    unauthorized_hint: "تواصل مع المسؤول لترقية دورك ثم سجّل الدخول مجددًا.",
    nav_dashboard: "لوحة القيادة التنفيذية",
    nav_usecases: "حالات الاستخدام",
    nav_absorption: "مركز التبني",
    nav_integrations: "التكاملات",
    nav_admin: "الإدارة",
    nav_audio: "سجلات الصوت",
    dashboard: "لوحة القيادة التنفيذية",
    portfolio_value: "قيمة محفظة الذكاء الاصطناعي",
    realised_value: "القيمة المحققة",
    potential_value: "القيمة المحتملة",
    annual_value: "القيمة السنوية المقدرة",
    active_models: "إجمالي حالات الاستخدام",
    high_risk: "حالات عالية المخاطر",
    roi: "عائد الاستثمار للمحفظة",
    avg_adoption: "متوسط التبني",
    hidden_cost: "التكلفة الخفية للذكاء الاصطناعي",
    hidden_cost_desc: "التبني هو أكبر تكلفة خفية — التقنية وحدها لا تُوسّع القيمة.",
    layer_readiness: "جاهزية الطبقات الخمس",
    top_roi: "أعلى حالات عائد الاستثمار",
    critical_priority: "أولوية المخاطر الحرجة",
    usecases_by_domain: "حالات الاستخدام حسب المجال",
    use_cases: "حالات الاستخدام",
    use_cases_count: "100 حالة استخدام مؤسسية للذكاء الاصطناعي",
    search: "ابحث في حالات الاستخدام...",
    all: "الكل",
    domain: "المجال",
    status: "الحالة",
    risk: "المخاطر",
    readiness: "الجاهزية",
    owner: "المالك",
    value: "القيمة",
    export: "تصدير CSV",
    view_details: "عرض التفاصيل",
    model: "النموذج",
    system: "النظام",
    operation: "التشغيل",
    absorption: "التبني",
    outcome: "النتيجة",
    score: "النتيجة",
    gaps: "الفجوات المحددة",
    actions: "بنود العمل",
    no_gaps: "لا توجد فجوات — الطبقة جاهزة",
    overall_readiness: "الجاهزية الإجمالية",
    business_owner: "مالك العمل",
    ai_owner: "مالك الذكاء الاصطناعي",
    implementation_cost: "تكلفة التنفيذ",
    operating_cost: "تكلفة التشغيل السنوية",
    estimated_benefit: "الفائدة المقدرة",
    adoption_rate: "معدل التبني",
    not_proven: "التقنية تعمل، لكن القيمة التنظيمية لم تُثبت بعد.",
    absorption_center: "مركز التبني",
    absorption_readiness: "جاهزية التبني",
    absorption_desc: "الجاهزية للإنتاج لا تعني الجاهزية التنظيمية. القيمة تتوسع فقط عندما يتغير السلوك والملكية وسير العمل.",
    readiness_dimensions: "أبعاد الجاهزية",
    at_risk_absorption: "حالات معرضة لخطر التبني",
    integrations: "التكاملات والوظائف",
    integrations_desc: "وسّع المنصة بوظائف مخصصة وتكاملات واجهات برمجية.",
    add_integration: "إضافة تكامل",
    connected: "متصل",
    not_connected: "غير متصل",
    administration: "الإدارة",
    users: "المستخدمون",
    groups: "المجموعات",
    content: "المحتوى",
    activity: "سجل النشاط",
    add_user: "إضافة مستخدم",
    add_group: "إضافة مجموعة",
    name: "الاسم",
    role: "الدور",
    group: "المجموعة",
    actions_col: "إجراءات",
    members: "الأعضاء",
    upload_content: "رفع محتوى",
    download: "تنزيل",
    filename: "اسم الملف",
    size: "الحجم",
    uploaded_by: "رفع بواسطة",
    admin_only: "المسؤول الافتراضي فقط يمكنه رفع وتنزيل المحتوى.",
    audio_logs: "سجلات القراءة الصوتية",
    audio_logs_desc: "يُسجّل كل ملخص منطوق مع الدور والشاشة والمدة.",
    screen: "الشاشة",
    duration: "المدة",
    language: "اللغة",
    read_aloud: "اقرأ بصوت عالٍ",
    generating_summary: "جارٍ إنشاء الملخص...",
    play: "تشغيل",
    pause: "إيقاف مؤقت",
    stop: "إيقاف",
    speed: "السرعة",
    transcript: "النص",
    copy: "نسخ",
    voice_summary: "ملخص صوتي",
    voice_ask: "اسأل بصوتك",
    listening: "يستمع...",
    transcribing: "جارٍ التفريغ...",
    save: "حفظ",
    cancel: "إلغاء",
    delete: "حذف",
    edit: "تعديل",
    confirm: "تأكيد",
    total_use_cases: "إجمالي حالات الاستخدام",
    close: "إغلاق",
    principle: "قد ينجح العرض التوضيحي. وقد تنجح التقنية. لكن إذا لم يتغير السلوك والملكية وسير العمل، فلن تتوسع القيمة.",
  },
};
